import {
  Activity,
  Megaphone,
  AlertCircle,
  AlertTriangle,
  AlignCenter,
  AlignLeft,
  AlignRight,
  Archive,
  Coffee,
  ArrowBigDown,
  ArrowBigUp,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  BadgeCheck,
  Bell,
  Blocks,
  Book,
  Bold,
  Bot,
  Brain,
  Braces,
  Bug,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronsUp,
  Circle,
  Clipboard,
  Cloud,
  CloudCog,
  CloudDownload,
  CloudUpload,
  Code,
  Cog,
  Coins,
  Copy,
  Cpu,
  Crown,
  Database,
  Diamond,
  Download,
  Edit,
  Ellipsis,
  ExternalLink,
  Eye,
  File,
  FilePlus,
  FileText,
  Folder,
  FolderOpen,
  FolderPlus,
  Globe,
  GripVertical,
  HardDrive,
  Headset,
  Home,
  Image,
  Italic,
  Key,
  Link,
  List,
  ListOrdered,
  Lock,
  LogOut,
  Mail,
  MessageCircle,
  MessageSquare,
  Minus,
  Moon,
  Network,
  Package,
  Palette,
  Pause,
  PenLine,
  Play,
  Plus,
  Power,
  Quote,
  RefreshCcw,
  RefreshCw,
  Rocket,
  Router,
  Search,
  Send,
  Server,
  Settings,
  Shield,
  ShieldCheck,
  ShoppingCart,
  Sparkles,
  Square,
  SquareCheck,
  Star,
  Sun,
  Tag,
  Terminal,
  Thermometer,
  Ticket,
  Trash2,
  Underline,
  Unlink,
  Upload,
  User,
  UserCheck,
  UserCog,
  UserPlus,
  UserX,
  Users,
  Video,
  Wrench,
  X,
  Clock,
} from 'lucide-react';

export const IconActivity = Activity;
export const IconAd = Megaphone;
export const IconAdOff = Megaphone;
export const IconAlertCircle = AlertCircle;
export const IconAlertTriangle = AlertTriangle;
export const IconAlignCenter = AlignCenter;
export const IconAlignLeft = AlignLeft;
export const IconAlignRight = AlignRight;
export const IconArchive = Archive;
export const IconArrowBack = ArrowLeft;
export const IconArrowBigDown = ArrowBigDown;
export const IconArrowBigUp = ArrowBigUp;
export const IconArrowLeft = ArrowLeft;
export const IconArrowRight = ArrowRight;
export const IconArrowUp = ArrowUp;
export const IconBell = Bell;
export const IconBold = Bold;
export const IconBolt = ChevronsUp;
export const IconBook = Book;
export const IconBrain = Brain;
export const IconBrandDiscord = MessageCircle;
export const IconBrandFacebook = Globe;
export const IconBrandGoogleDrive = HardDrive;
export const IconBrandInstagram = Image;
export const IconBrandOnedrive = Cloud;
export const IconBrandTiktok = Video;
export const IconBrandX = MessageSquare;
export const IconBrandYoutube = Video;
export const IconBuildingFactory2 = Blocks;
export const IconCalendar = Calendar;
export const IconChartBar = Megaphone;
export const IconCheck = Check;
export const IconCheckbox = SquareCheck;
export const IconChevronDown = ChevronDown;
export const IconChevronRight = ChevronRight;
export const IconCircleFilled = Circle;
export const IconClipboard = Clipboard;
export const IconCloud = Cloud;
export const IconCloudComputing = CloudCog;
export const IconCloudUpload = CloudUpload;
export const IconCode = Code;
export const IconCoin = Coins;
export const IconCopy = Copy;
export const IconCreditCard = BadgeCheck;
export const IconCpu = Cpu;
export const IconCoffee = Coffee;
export const IconCrown = Crown;
export const IconDatabase = Database;
export const IconDeviceFloppy = SaveIcon;
export const IconDiamond = Diamond;
export const IconDots = Ellipsis;
export const IconDownload = Download;
export const IconEdit = Edit;
export const IconExternalLink = ExternalLink;
export const IconEye = Eye;
export const IconFile = File;
export const IconFilePlus = FilePlus;
export const IconFileText = FileText;
export const IconFolder = Folder;
export const IconFolderOpen = FolderOpen;
export const IconFolderPlus = FolderPlus;
export const IconGlobe = Globe;
export const IconGripVertical = GripVertical;
export const IconHeadset = Headset;
export const IconHome = Home;
export const IconItalic = Italic;
export const IconKey = Key;
export const IconLink = Link;
export const IconList = List;
export const IconListNumbers = ListOrdered;
export const IconLoader = RefreshCw;
export const IconLock = Lock;
export const IconLogout = LogOut;
export const IconMail = Mail;
export const IconMessage = MessageSquare;
export const IconMessageCircle = MessageCircle;
export const IconMoon = Moon;
export const IconNetwork = Network;
export const IconPackage = Package;
export const IconPalette = Palette;
export const IconPencil = PenLine;
export const IconPhoto = Image;
export const IconPlayerPlay = Play;
export const IconPlayerStop = Pause;
export const IconPlus = Plus;
export const IconPower = Power;
export const IconQuote = Quote;
export const IconRefresh = RefreshCcw;
export const IconRestore = RefreshCw;
export const IconRobot = Bot;
export const IconRocket = Rocket;
export const IconRouter = Router;
export const IconSearch = Search;
export const IconSend = Send;
export const IconServer = Server;
export const IconServerCog = UserCog;
export const IconSettings = Settings;
export const IconShield = Shield;
export const IconShieldCheck = ShieldCheck;
export const IconShoppingCart = ShoppingCart;
export const IconSparkles = Sparkles;
export const IconSquare = Square;
export const IconStar = Star;
export const IconStarFilled = Star;
export const IconStrikethrough = Minus;
export const IconSun = Sun;
export const IconTag = Tag;
export const IconTerminal2 = Terminal;
export const IconThermometer = Thermometer;
export const IconTicket = Ticket;
export const IconTools = Wrench;
export const IconTrash = Trash2;
export const IconUnderline = Underline;
export const IconUnlink = Unlink;
export const IconUpload = Upload;
export const IconUser = User;
export const IconUserCheck = UserCheck;
export const IconUserCircle = User;
export const IconUserOff = UserX;
export const IconUserPlus = UserPlus;
export const IconUsers = Users;
export const IconVideo = Video;
export const IconWorld = Globe;
export const IconWorldOff = Globe;
export const IconX = X;
export const IconClock = Clock;

function SaveIcon(props: any) {
  return <Database {...props} />;
}

